import React from 'react';
import { Box, Card, CardHeader, CardContent } from '@mui/material';
import TradeFilters from '../common/TradeFilters';
import TradeHistoryTable from '../trades/TradeHistoryTable';

const TradeHistorySection = ({
  filteredTrades,
  selectedCategory,
  selectedSymbol,
  selectedStrategy,
  selectedTags,
  startDate,
  endDate,
  onCategoryChange,
  onSymbolChange,
  onStrategyChange,
  onTagsChange,
  onStartDateChange,
  onEndDateChange,
  onTimeFilter,
  symbols,
  strategies,
  allTags,
  strategyNamesMap,
  onEditTrade,
  onUpdateTrade,
  onRefresh,
  onDeleteSuccess
}) => {
  return (
    <Box mt={4}>
      <Card elevation={2}>
        <CardHeader
          title="All Trades"
          subheader="Filter and manage your trading records"
        />
        <CardContent>
          <TradeFilters
            selectedCategory={selectedCategory}
            selectedSymbol={selectedSymbol}
            selectedStrategy={selectedStrategy}
            selectedTags={selectedTags}
            startDate={startDate}
            endDate={endDate}
            onCategoryChange={onCategoryChange}
            onSymbolChange={onSymbolChange}
            onStrategyChange={onStrategyChange}
            onTagsChange={onTagsChange}
            onStartDateChange={onStartDateChange}
            onEndDateChange={onEndDateChange}
            onTimeFilter={onTimeFilter}
            symbols={symbols}
            strategies={strategies.map(s => s.strategyId)}
            allTags={allTags}
            strategyNamesMap={strategyNamesMap}
          />
        </CardContent>
      </Card>
      
      <Box mt={3}>
        <TradeHistoryTable
          trades={filteredTrades}
          onEditTrade={onEditTrade}
          onUpdateTrade={onUpdateTrade}
          onRefresh={onRefresh}
          onDeleteSuccess={onDeleteSuccess}
          strategies={strategies}
        />
      </Box>
    </Box>
  );
};

export default TradeHistorySection;